import React from "react";
import icons from "../helpers/icons";
import {formatDate} from "../helpers/util";


const SunnhetUndersoekelser = (props) => {

    const undersoekelser = props.undersoekelser;
    const rows = undersoekelser.map((undersoekelse, index) => (
        <Undersoekelse key={undersoekelse.id} undersoekelse={undersoekelse} index={index} />
    ));
    if (undersoekelser.length === 0) {
       return <div className="dogweb-card"></div>
    }
    return (
        <div className="tabs-panel is-active">
            {rows}
        </div>
    );
};

const Undersoekelse = (props) => {
    const undersoekelse = props.undersoekelse;
    const index = props.index;

    if (undersoekelse.hdAdOcd) {
        let delDiagnoser = null;

        if (undersoekelse.diagnoseVenstre != null || undersoekelse.diagnoseHoeyre != null) {
            delDiagnoser = "(Venstre: ";
            if (undersoekelse.diagnoseVenstre != null) delDiagnoser += undersoekelse.diagnoseVenstre;
            else delDiagnoser += "Ikke registrert";

            delDiagnoser += ", Højre: ";
            if (undersoekelse.diagnoseHoeyre != null) delDiagnoser += undersoekelse.diagnoseHoeyre;
            else delDiagnoser += "Ikke registrert";

            delDiagnoser += ")";
        }
        return (
            <div className="dogweb-card">
                { !undersoekelse.diagnoseBareRegistrertPaaHund &&
                    <>
                        <h3>{undersoekelse.type}-Diagnose: {undersoekelse.diagnose} {delDiagnoser != null && <span style={{ fontSize: "15px" }}>{delDiagnoser}</span>}</h3>

                        {
                            !undersoekelse.uoffisiell && undersoekelse.raseSunnetResultatKrav === null &&
                            <p><em>{undersoekelse.type} undersøgelse er frivillig for racen</em></p>
                        }
                        {
                            undersoekelse.diagnoseDato === null &&
                            <p><span>Bestilt foto:</span> {formatDate(undersoekelse.rontgenDato)}</p>
                        }
                        {
                            undersoekelse.diagnoseDato !== null &&
                            <span>
                                <p><span>Bedømt:</span> {formatDate(undersoekelse.diagnoseDato)}</p>
                            </span>
                        }
                        <p><span>Dyrlæge:</span> {undersoekelse.dyrlegeNavn}</p>
                        <p><span> {undersoekelse.type}:</span> {undersoekelse.id}
                            {
                                undersoekelse.utenlandsk &&
                                ' (udenlandsk)'
                            }
                        </p>

                        {
                            /*
                             undersoekelse.dokumentUrl !== null &&
                            <a href={undersoekelse.dokumentUrl} className="document-link" rel="noopener noreferrer" target="_blank">
                                <img className="icon icon-result" src={icons.document} alt="" />
                                Dokument</a>

                             */
                        }
                    </>
                }

                {
                    undersoekelse.diagnoseBareRegistrertPaaHund &&
                        <>
                            <h3>{undersoekelse.type}-diagnose {undersoekelse.diagnose}</h3>
                            {
                                !undersoekelse.uoffisiell && undersoekelse.raseSunnetResultatKrav === null &&
                                <p><em>{undersoekelse.type} undersøgelse er frivillig for racen</em></p>
                            }
                        </>
                }


                <p><span></span></p>
            </div>
        );
    }
    else if (undersoekelse.ecvo) {
        return (
            <div className="dogweb-card">
                {

                    index == 0 && !undersoekelse.uoffisiell && undersoekelse.raseSunnetResultatKrav === null &&
                    <p><em>ECVO undersøgelse er frivillig for racen</em></p>
                }
                <h3>Øjne ECVO attest - {formatDate(undersoekelse.lystDato)} </h3>
                <p><span>Reg.Dato:</span> {formatDate(undersoekelse.registrertDato)}</p>
                <p><span>Dyrlæge:</span> {undersoekelse.dyrlegeNavn}</p>
                <p><span>Diagnose:</span> {undersoekelse.diagnose}</p>
                {
                    undersoekelse.beskrivelse &&
                    <p>{undersoekelse.beskrivelse}</p>
                }
                {
                    undersoekelse.antallMndTilNyAnbefaltUndersoekelse !== null &&
                    <p><span>Genundersøgelse tilrådes om:</span> {undersoekelse.antallMndTilNyAnbefaltUndersoekelse}</p>
                }
                {undersoekelse.pdfEcvoAttestUrl &&
                    <a href={undersoekelse.pdfEcvoAttestUrl} className="document-link" rel="noopener noreferrer" target="_blank">
                        <img className="icon icon-result" src={icons.document} alt="" />
                        Dokument
                    </a>
                }


                <p><span></span></p>
            </div>
        );
    }
    return (
        <div className="dogweb-card">
            <h3>{undersoekelse.sykdomNavn}</h3>


            {
                !undersoekelse.uoffisiell && undersoekelse.raseSunnetResultatKrav === null &&
                <p><em>Undersøgelsen er frivillig for racen</em></p>
            }

            {
                undersoekelse.beskrivelse !== null &&
                    <p> {undersoekelse.beskrivelse}</p>
            }
            {
                undersoekelse.diagnose !== null &&
                <p><span>Diagnose:</span> {undersoekelse.diagnose} {undersoekelse.diagnoseTekst}</p>
            }
            {
                undersoekelse.diagnoseDato !== null &&
                <p><span>Diagnose dato:</span> {formatDate(undersoekelse.diagnoseDato)}</p>
            }
            {
                undersoekelse.godkjentAvl !== null &&
                <p>
                    {
                        undersoekelse.godkjentAvl && undersoekelse.gyldigTilDato == null &&
                        <span>Godkendt til avl</span>
                    }
                    {
                        undersoekelse.godkjentAvl && undersoekelse.gyldigTilDato != null &&
                        <span>Godkendt til avl indtil {formatDate(undersoekelse.gyldigTilDato)}</span>
                    }
                    {
                        undersoekelse.godkjentAvl === false &&
                        <span>Ikke godkendt til avl</span>
                    }
                </p>
            }
            <p><span>Registreringsdato:</span> {formatDate(undersoekelse.registrertDato)}</p>
            {
                undersoekelse.dokumentUrl !== null &&
                <a href={undersoekelse.dokumentUrl} rel="noopener noreferrer" className="document-link" target="_blank">
                    <img className="icon icon-result" src={icons.document} alt="" />Dokument</a>
            }
            <p><span></span></p>
        </div>
    );
};


export default SunnhetUndersoekelser;
